<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import HeaderLogo from "@/Components/Generics/HeaderLogo.vue";
import { defineComponent } from "vue";

export default defineComponent({
    name: "GenericNavigation",
    components: { HeaderLogo, GenericButton },
    props: {
        extraHeaderTitle: {
            type: String,
            default: null,
        },
        showLogin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scrolledTop: 0,
            navbarOpen: false,
        };
    },
    mounted() {
        window.addEventListener("scroll", this.scrollHandle);
        document.addEventListener("click", this.onDocumentClick);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.onDocumentClick);
        window.removeEventListener("scroll", this.scrollHandle);
    },
    methods: {
        scrollHandle(): void {
            this.scrolledTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
        },

        toggleNavbar(): void {
            this.navbarOpen = !this.navbarOpen;
        },
        closeNavbar(): void {
            this.navbarOpen = false;
        },

        onDocumentClick(event: MouseEvent): void {
            const navbar = this.$refs.refNavbar as HTMLElement;

            if (!this.navbarOpen) return;
            if (navbar.contains(event.target as Node)) return;

            this.closeNavbar();
        },
        onNavbarInnerClick(event: MouseEvent): void {
            const target = event.target as HTMLElement;

            if (!target.closest("a")) return;

            this.closeNavbar();
        },
        onClickDashboard(pageRoute: string): void {
            this.$inertia.visit(pageRoute);
        },
    },
});
</script>

<template>
    <div ref="refNavigationWrapper" :class="{ scrollDown: scrolledTop >= 1, collapseOpen: navbarOpen }" class="navigation-wrapper fixed-top flex flex--halign-c">
        <div class="navigation content-width flex flex--halign-sb flex--valign-c">
            <nav ref="refNavbar" class="navbar navbar-expand-lg">
                <div class="navbar-top">
                    <div class="navbar-brand">
                        <slot name="title">
                            <HeaderLogo :extra-title="extraHeaderTitle" :logo-small="scrolledTop >= 1" />
                        </slot>
                    </div>

                    <div v-if="showLogin" class="navbar-login">
                        <GenericButton circular :title="$trans('navigation.nav_login')" @click="onClickDashboard('/login')" />
                        <GenericButton circular secondary :title="$trans('navigation.nav_register')" @click="onClickDashboard('/register')" />
                    </div>

                    <button class="navbar-toggler" type="button" :aria-expanded="navbarOpen" aria-controls="navbarNav" aria-label="Toggle navigation" @click="toggleNavbar">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>

                <div id="navbarNav" ref="refNavbarCollapse" class="navbar-collapse navbar-collapse-custom" :class="{ show: navbarOpen }">
                    <div class="navbar-collapse-inner" @click="onNavbarInnerClick">
                        <slot></slot>

                        <div v-if="showLogin" class="navbar-login-inner">
                            <GenericButton circular small :title="$trans('navigation.nav_login')" @click="onClickDashboard('/login')" />
                            <GenericButton circular small secondary :title="$trans('navigation.nav_register')" @click="onClickDashboard('/register')" />
                        </div>
                    </div>
                </div>

                <!-- <div ref="refNavbarCollapse" class="collapse navbar-collapse" id="navbarNav">
                    <div class="navbar-collapse-inner">
                        <slot></slot>
                    </div>
                </div> -->
            </nav>
        </div>
    </div>

    <!-- <div :class="{ scrollDown: scrolledTop >= 100 }" class="navigation-wrapper fixed-top flex flex--halign-c">
        <div class="navigation content-width flex flex--halign-sb flex--valign-c">
            <div class="flex--extend">
                <slot name="title">
                    <HeaderLogo :extra-title="extraHeaderTitle" :logo-small="scrolledTop >= 100" />
                </slot>
            </div>
            <nav class="navbar navbar-expand-md navbar-dar">
                <div class="full-width">
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <slot></slot>
                    </div>
                </div>
            </nav>
        </div>
    </div> -->
</template>

<style lang="scss" scoped></style>
